import { useEffect } from "react";
import { BackButton, Button } from "../../components";
import { useSearchParams } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import LineItem from "./LineItem";
import SubmitWarrntyItems from "./SubmitWarrntyItems";
import { connect, useDispatch } from "react-redux";
import Loader from "../../components/Loader";
import { RootState } from "../../store/root-reducer";
import { WarrntyItemScope } from "../../store/add-warrnty-item/types";
import { isScopeLoading } from "../../store/scope-loading/helpers";
import {
  addWarrntyItem,
  setWarrntyClaimId,
} from "../../store/add-warrnty-item/actions";
import { useTranslation } from "react-i18next";

function AddWarrantyItem({ loading }) {
  const [searchParams] = useSearchParams();
  const formMethods = useForm({
    defaultValues: {
      vendor: "",
      sku: "",
      model: "",
      quantity: 1,
      price: "",
      itemType: "",
      manufacturer: "",
      material: "",
      color: "",
    },
  });
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { handleSubmit } = formMethods;

  const claimId: string = searchParams.get("claimId") || "";
  const warranty_id: string = searchParams.get("warranty_id") || "";

  useEffect(() => {
    dispatch(setWarrntyClaimId({ warranty_id, claim_id: claimId }));
    return () => {};
  }, [claimId, dispatch, warranty_id]);

  const handleSubmitItem = (values) => {
    dispatch(
      addWarrntyItem({
        claimId,
        warrentyId: warranty_id,
        vendor: values?.vendor || "",
        sku: values?.sku || "",
        modelNumber: values?.model || "",
        quantity: values?.quantity || "",
        price: values?.price || "",
        itemType: values?.itemType || "",
        manuFacturer: values?.manuFacturer || "",
        material: values?.material || "",
        color: values?.color || "",
        description: values.description || "",
      })
    );
  };

  return (
    <div className="px-4 bg-white">
      <div className="mb-8 mt-6 flex justify-between items-center">
        <BackButton />
      </div>
      <div className="mb-2">
        <h3 className="text-2xl font-semibold">{t("Missing Line Item.")}</h3>
      </div>
      <form className="grid gap-y-4" onSubmit={handleSubmit(handleSubmitItem)}>
        <Loader isLoading={loading} />
        <FormProvider {...formMethods}>
          <LineItem />
        </FormProvider>
        <Button submit className="my-4">
          {t("Submit")}
        </Button>
        <SubmitWarrntyItems />
      </form>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  loading: isScopeLoading(state.scopeLoading, WarrntyItemScope),
});

export default connect(mapStateToProps)(AddWarrantyItem);
